import Drawer from '@mui/material/Drawer';
import React, { ReactNode } from 'react';

const CustomDrawer = ({
  children,
  onClose,
  state,
}: {
  children: ReactNode;
  onClose: (event: React.KeyboardEvent | React.MouseEvent) => void;
  state: boolean;
}) => {
  return (
    <Drawer anchor={'right'} open={state} aria-hidden='false'>
      {children}
    </Drawer>
  );
};

export default CustomDrawer;
